module.exports = __webpack_public_path__ + "static/media/loader.e9d9e9f1.gif";